import { FC } from 'react'
import { Flex, Skeleton } from 'antd'

const MockWordList: FC = () => {
    return (
        <li className="dictionary__word-list-item" style={{ cursor: 'default' }}>
            <Skeleton.Avatar active shape="square" size={44} style={{ borderRadius: 8 }} />
            <div className="word-list-item__info">
                <Skeleton.Input active size="small" style={{ width: 140, height: 16 }} />
                <Skeleton.Input active size="small" style={{ width: 60, height: 12, marginTop: 4 }} />
            </div>
            <Flex gap={4} align="center">
                <Skeleton.Button active size="small" style={{ width: 36, height: 36 }} />
                <Skeleton.Button active size="small" style={{ width: 36, height: 36 }} />
                <Skeleton.Button active size="small" style={{ width: 36, height: 36 }} />
            </Flex>
        </li>
    )
}

export default MockWordList
